import React from 'react';
import propTypes from 'prop-types';
import Modal from 'tailwind-components/Modal/Modal';
import Button from 'tailwind-components/Button/Button';

function OnboardingCancelConfirmModal({
  record,
  open,
  onClose,
  onConfirm,
  isSubmitting = false
}) {
  if (!record) return null;

  return (
    <Modal
      active={open}
      closeModal={onClose}
      title='Cancel onboarding?'
      size='medium'
      footer={
        <div
          data-tour='onboarding-cancel-modal-footer'
          className='flex w-full flex-wrap justify-end gap-2'
        >
          <Button
            variant='secondary'
            text='Go back'
            onClick={onClose}
            size='small'
            isDisabled={isSubmitting}
            data-tour='onboarding-cancel-modal-close'
          />
          <Button
            variant='danger'
            text='Cancel onboarding'
            onClick={() => onConfirm(record)}
            size='small'
            isLoading={isSubmitting}
            isDisabled={isSubmitting}
          />
        </div>
      }
    >
      <div
        data-tour='onboarding-cancel-modal'
        className='flex flex-col gap-3 text-left'
      >
        <p className='m-0 rounded-md border border-grey-lighter bg-grey-lightest px-3 py-2 text-sm font-medium text-black'>
          This action cannot be undone. The agent will be removed from the
          current onboarding flow in this dashboard.
        </p>
        <dl className='m-0 grid gap-2 text-sm'>
          <div>
            <dt className='m-0 text-xs font-medium uppercase tracking-wide text-grey'>
              Agent
            </dt>
            <dd className='m-0 font-semibold text-black'>
              {record.agentName || '—'}
            </dd>
          </div>
          <div>
            <dt className='m-0 text-xs font-medium uppercase tracking-wide text-grey'>
              NPN
            </dt>
            <dd className='m-0 font-mono text-black'>{record.npn || '—'}</dd>
          </div>
          <div>
            <dt className='m-0 text-xs font-medium uppercase tracking-wide text-grey'>
              Agency
            </dt>
            <dd className='m-0 text-black'>{record.relatedToAgency || '—'}</dd>
          </div>
          <div>
            <dt className='m-0 text-xs font-medium uppercase tracking-wide text-grey'>
              Status
            </dt>
            <dd className='m-0 text-black'>{record.groupLabel || '—'}</dd>
          </div>
        </dl>
      </div>
    </Modal>
  );
}

OnboardingCancelConfirmModal.propTypes = {
  record: propTypes.object,
  open: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
  onConfirm: propTypes.func.isRequired,
  isSubmitting: propTypes.bool
};

export default OnboardingCancelConfirmModal;
